function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.4338 0C12.0511 0 10.8767 0.942082 10.4352 2.23308H3.19853C1.441 2.23308 0 3.74216 0 5.58271V27.4173C0 29.2578 1.441 30.7669 3.19853 30.7669H14.0735V30.7756C14.0735 32.0056 15.0231 33 16.1892 33H26.876C28.0504 33 29 32.0056 29 30.7756V15.6141C29 14.3929 28.0504 13.3985 26.876 13.3985H26.8676V5.58271C26.8676 3.74216 25.4266 2.23308 23.6691 2.23308H16.4324C15.991 0.942082 14.8165 0 13.4338 0ZM13.4338 2.23308C14.0335 2.23308 14.5 2.72157 14.5 3.34962V4.46617H16.6324V6.69925H10.2353V4.46617H12.3676V3.34962C12.3676 2.72157 12.8341 2.23308 13.4338 2.23308ZM3.19853 4.46617H8.10294V8.93233H18.7647V4.46617H23.6691C24.2688 4.46617 24.7353 4.95465 24.7353 5.58271V13.3985H16.1892C15.0231 13.3985 14.0735 14.3929 14.0735 15.6141V28.5338H3.19853C2.59881 28.5338 2.13235 28.0453 2.13235 27.4173V5.58271C2.13235 4.95465 2.59881 4.46617 3.19853 4.46617ZM16.1892 15.6316H26.8676L26.876 30.7669L16.2059 30.7756L16.1892 15.6316Z",
  fill: "#D4643C"
});

const SvgSop = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgSop, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/SOP.c0872633.svg";
export { ForwardRef as ReactComponent };